import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { StateProject, StateProjectForm } from '../models';

@Injectable()
export class StateProjectService {

    stateProjectsUrl = environment.dns + 'api/state/projects/';

    constructor(private http: HttpClient) { }

    getList(): Observable<StateProject[]> {
        return this.http.get<StateProject[]>(this.stateProjectsUrl + 'list');
    }

    getOne(id: number): Observable<StateProject> {
        return this.http.get<StateProject>(this.stateProjectsUrl + id);
    }

    add(stateProjectForm: StateProjectForm): Observable<StateProject> {
        return this.http.post<StateProject>(this.stateProjectsUrl, stateProjectForm);
    }

    update(stateProjectForm: StateProjectForm): Observable<StateProject> {
        return this.http.put<StateProject>(this.stateProjectsUrl, stateProjectForm);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.stateProjectsUrl + id);
    }
}